import { computed } from "vue";
import { useRoute } from "vue-router";

export function useRouteHelpers() {
    const route = useRoute();

    const isHomePage = computed(() => route.path === '/');
    const isYachtsPage = computed(() => route.path.startsWith('/yachts'));
    const isYachtPage = computed(() => /^\/yachts\/[^/]+$/.test(route.path));

    const isAboutPage = computed(() => route.path === '/aboutUs');
    const isDestinationsPage = computed(() => route.path === '/destinations');
    const isDestinationPage = computed(() => /^\/destinations\/[^/]+$/.test(route.path));

    const isGuidePage = computed(() => route.path === '/guide');
    const isInquiryPage = computed(() => route.path === '/inquiry');
    const isMultiYachtsInquiryPage = computed(() => route.path === '/yachtsInquiry');

    const isBlogArticlePage = computed(() => /^\/magazine\/[^/]+$/.test(route.path));
    const isBlogPage = computed(() => route.path.startsWith('/magazine'));
    const isImprintPage = computed(() => route.path.startsWith('/imprint'));



    return {
        isHomePage,
        isYachtsPage,
        isYachtPage,
        isAboutPage,
        isDestinationsPage,
        isDestinationPage,
        isGuidePage,
        isInquiryPage,
        isMultiYachtsInquiryPage,
        isBlogArticlePage,
        isBlogPage,
        isImprintPage
    };
}
